/**
 * @description returns a string out of an object.
 */
export const objectToString = object => JSON.parse(JSON.stringify(object)); // Handling an object as JSON removes any entries that have no values in it
